import { useEffect, useState } from "react";
import bg_hero from "../assets/bg-hero.jpg";
import Scaffold from "@/components/Scaffold";
import { Link } from "react-router-dom";
import { convertTo12HourFormat } from "@/utils/constants";
import { apiCallback } from "@/utils/api_config";

function App() {
  const time = [
    "10:30:00",
    "11:30:00",
    "12:30:00",
    "13:30:00",
    "16:30:00",
    "17:30:00",
    "18:30:00",
    "19:30:00",
    "20:30:00",
    "21:30:00",
  ];
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState<Record<string, any[]>>({});
  const [liveLink, setliveLink] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [timeFilter, setTimeFilter] = useState("All");

  async function fetchResults() {
    try {
      setLoading(true);
      const formdata = new FormData();
      formdata.append("fromDate", fromDate);
      formdata.append("toDate", toDate);
      formdata.append("timeFilter", timeFilter);

      const res = await apiCallback.post("/results/fetch-results", formdata);
      console.log(res.data.message);

      if (!res.data.error) {
        setResults(res.data.response.results);
        setliveLink(res.data.response.liveResultLink);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchResults();
  }, [fromDate, toDate, timeFilter]);

  return (
    <Scaffold isLoading={loading}>
      <div className="bg w-full overflow-y-auto h-screen relative">
        <div className="fixed inset-0 z-0">
          <img
            src={bg_hero}
            alt="Background"
            className="w-full h-screen object-cover"
          />
          <div className="absolute h-screen inset-0 bg-black/50"></div>
        </div>
        <div className="relative z-10">
          <div className="md:p-10 p-2">
            <div className="md:p-20 p-5 md:py-[70px] py-[20px] bg-black/80 text-white border border-gray-700 rounded-xl">
              <div className="flex justify-between items-center">
                <div className="text-start">
                  <h1 className="md:text-7xl md:text-[40px] text-[30px] font-bold">
                    3 Circle Results
                  </h1>
                  <p className="md:text-2xl text-sm tracking-wide mt-2 italic">
                    "Find results before anywhere else"
                  </p>
                  <p className="md:text-2xl text-sm tracking-wide mt-2">
                    We do not publish fake results | हम नकली परिणाम प्रकाशित
                    नहीं करते
                  </p>
                </div>
                <div className="md:h-[300px] h-[100px] rounded-full overflow-hidden drop-shadow-xl flex-shrink-0">
                  <img
                    src="3circle-logo.png"
                    alt=""
                    className="w-full h-full object-contain mx-auto"
                  />
                </div>
              </div>
              <div className="flex flex-wrap gap-2 mt-10">
                <button
                  onClick={() => {
                    document.getElementById("results")?.scrollIntoView({
                      behavior: "smooth",
                      block: "start",
                      inline: "nearest",
                    });
                  }}
                  className="bg-gray-700 hover:bg-black rounded-full px-5 py-2 text-md flex-col text-center items-center"
                >
                  View Results
                </button>
                <Link
                  to={`/live-result`}
                  target="_blank"
                  className="bg-red-600 hover:bg-red-900 text-white rounded-full px-5 py-2 text-md flex-col text-center items-center"
                >
                  Live Result
                </Link>
              <a
  href="https://threecircle5.com/downloads/three-circle.apk"
  target="_blank"
  rel="noopener noreferrer"
  download
>
  <div className="flex gap-2 bg-green-700 hover:bg-green-900 text-white rounded-full px-5 py-2 text-md text-center items-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
      />
    </svg>
    Download App
  </div>
</a>

              </div>
            </div>
            <section id="results" className="md:mt-10 mt-5 md:flex gap-10">
              <div className="items-start  mb-5 h-[300px] md:sticky top-10">
                <div className="bg-black p-5 rounded-xl flex flex-col gap-2">
                  <h1 className="text-2xl md:text-5xl font-semibold mb-5 text-white">
                    Results
                  </h1>

                  <div className="grid md:grid-cols-2 grid-cols-1 items-center md:gap-3 gap-2">
                    <div>
                      <p className="text-sm text-white mb-1">From Date</p>
                      <input
                        type="date"
                        name="fromDate"
                        id="fromDate"
                        value={fromDate}
                        onChange={(e) => {
                          setFromDate(e.target.value);
                        }}
                        className="p-2 rounded-xl bg-gray-700 text-white w-full"
                      />
                    </div>
                    <div>
                      <p className="text-sm text-white mb-1">To Date</p>
                      <input
                        type="date"
                        name="toDate"
                        id="toDate"
                        value={toDate}
                        onChange={(e) => {
                          setToDate(e.target.value);
                        }}
                        className="p-2 rounded-xl bg-gray-700 text-white w-full"
                      />
                    </div>
                  </div>
                  <div>
                    <p className="text-sm text-white mb-1">Time Slot</p>
                    <select
                      name="timeSlot"
                      id="timeSlot"
                      className="p-2 rounded-xl bg-gray-700 text-white w-full"
                      value={timeFilter}
                      onChange={(e) => {
                        setTimeFilter(e.target.value);
                      }}
                    >
                      <option value="All">All</option>
                      {time.map((val) => (
                        <option key={val} value={val}>
                          {convertTo12HourFormat(val)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="flex-1">
                {Object.keys(results)
                  .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())
                  .map((date, index) => (
                    <div
                      key={index}
                      className="mb-10 bg-black/70 rounded-xl border border-gray-600 p-5"
                    >
                      <p className="text-xl font-semibold  text-white md:mb-10 mb-5">
                        {date}
                      </p>
                      <ResultSection arr={results[date]} />
                    </div>
                  ))}
              </div>
            </section>
          </div>
        </div>

        <button
          onClick={() => {
            document.getElementById("results")?.scrollIntoView({
              behavior: "smooth",
              block: "start",
              inline: "nearest",
            });
          }}
          className="fixed z-50 bottom-10 right-10 bg-red-500 p-[20px] rounded-full"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-6 text-white rotate-180"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3"
            />
          </svg>
        </button>
      </div>
    </Scaffold>
  );
}

export default App;

function ResultSection({ arr = [] }: { arr?: Array<Record<string, any>> }) {
  const resultsByTime: Record<string, any> = {};
  if (Array.isArray(arr)) {
    arr.forEach((result) => {
      const timeKey = Object.keys(result)[0];
      resultsByTime[timeKey] = result[timeKey];
    });
  }

  return (
    <div className="grid lg:grid-cols-7 md:grid-cols-5 grid-cols-4 justify-between gap-2 mt-2">
      {Object.keys(resultsByTime).map((timeSlot, index) => (
        <Tile key={index} data={resultsByTime[timeSlot]} timeSlot={timeSlot} />
      ))}
    </div>
  );
}

function Tile({ data, timeSlot }: { data?: any; timeSlot: string }) {
  return (
    <div className="text-center items-center gap-2 bg-gray-700 text-white flex-1 rounded-xl hover:scale-125 hover:drop-shadow-lg transition-all duration-300 md:p-1">
      <p className="bg-blue-600 text-white md:rounded-full rounded-md md:p-2 p-1 md:text-sm text-[12px] truncate">
        {timeSlot}
      </p>
      <div className="flex flex-col divide-y-[1px] divide-slate-500 md:p-2">
        <p className="resultText">{data?.colorResult ?? "-"}</p>
        <p className="resultText">{data?.singleResult ?? "-"}</p>
        <p className="resultText">{data?.doubleResult ?? "-"}</p>
      </div>
    </div>
  );
}
